import axios from 'axios'

export default {
  getAllWeatherStations: (locationId) => axios.get(`/api/v1/location/${locationId}/weather-station`),
  createWeatherStation: (locationId, data) => axios.post(`/api/v1/location/${locationId}/weather-station/`, data),
  getWeatherStation: (locationId, weatherStationId) => axios.get(`/api/v1/location/${locationId}/weather-station/${weatherStationId}`),
  updateWeatherStation: (locationId, weatherStationId, data) => axios.put(`/api/v1/location/${locationId}/weather-station/${weatherStationId}`, data),
  deleteWeatherStation: (locationId, weatherStationId) => axios.delete(`/api/v1/location/${locationId}/weather-station/${weatherStationId}`)
}
